<template>
  <label class="form__Label" :for="forID" v-if="label !== undefined || tooltip !== undefined">
    <template v-if="label !== undefined">
      {{ label }}
    </template>
    <Tooltip v-if="hasTooltip || $parent?.$slots?.tooltip" :text="tooltip" :click-only="tooltipClickOnly">
      <slot />
    </Tooltip>
  </label>
</template>

<script setup>
  defineProps({
    forID: {
      type: String
    },
    label: {
      type: String
    },
    tooltip: {
      type: [String, Boolean]
    },
    hasTooltip: {
      type: Boolean,
      default: false
    },
    tooltipClickOnly: {
      type: Boolean,
      default: false
    }
  })
</script>
